<div class="container">
  <div class="left">
    <p><span class="green">{{ 'LOGIN_ERROR.TITLE' | translate }}</span></p>
    <p>{{ 'LOGIN_ERROR.ACCESS_DENIED' | translate }}</p>

  </div>

  <div class="right">
    <img class="login-error-img" src="assets/magicpallet_error.png" alt="login-error-image">

    <p><span class="green">{{ errorTitle | translate }}</span></p>

    <p class="error-message">{{ errorMessage | translate }}</p>

    <app-loading-button [label]="'LOGIN_ERROR.BACK_TO_PALLET' | translate" type="button" size="big"
                        color="primary" routerLink="/">
    </app-loading-button>
  </div>
</div>
